import en from './base/en/main.json';
import de from './base/de/main.json';
import es from './base/es/main.json';
import fr from './base/fr/main.json';
import it from './base/it/main.json';
import brandEn from './brandSpecific/en/main.json';
import brandDe from './brandSpecific/de/main.json';
import brandEs from './brandSpecific/es/main.json';
import brandFr from './brandSpecific/fr/main.json';
import brandIt from './brandSpecific/it/main.json';

// Convert to the format expected by the app
const formatTranslations = (translations, locale) => {
  return Object.keys(translations).reduce((acc, key) => {
    acc[`${key}.${locale}`] = translations[key];
    return acc;
  }, {});
};

// Merge base translations with brand-specific overrides
const mergeTranslations = (base, brandSpecific) => ({
  ...base,
  ...brandSpecific,
});

export const defaultMessages = {
  ...formatTranslations(mergeTranslations(en, brandEn), 'en'),
  ...formatTranslations(mergeTranslations(de, brandDe), 'de'),
  ...formatTranslations(mergeTranslations(es, brandEs), 'es'),
  ...formatTranslations(mergeTranslations(fr, brandFr), 'fr'),
  ...formatTranslations(mergeTranslations(it, brandIt), 'it'),
};

export default defaultMessages;
